import * as React from 'react'
import Svg from '../Svg'
export const SvgBoxEmpty = (props: React.SVGProps<SVGSVGElement>) => (
    <Svg
        viewBox="0 0 100 100"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        {...props}
    >
        <path d="M80 10H20c-5.5 0-10 4.5-10 10v60c0 5.5 4.5 10 10 10h60c5.5 0 10-4.5 10-10V20c0-5.5-4.5-10-10-10zm0 70H20V20h60v60z" />
    </Svg>
)
SvgBoxEmpty.isIcon = true
export default SvgBoxEmpty
